import { render, staticRenderFns } from "./NovelCreatePage.vue?vue&type=template&id=ef7c0d80"
import script from "./NovelCreatePage.vue?vue&type=script&lang=ts"
export * from "./NovelCreatePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef7c0d80')) {
      api.createRecord('ef7c0d80', component.options)
    } else {
      api.reload('ef7c0d80', component.options)
    }
    module.hot.accept("./NovelCreatePage.vue?vue&type=template&id=ef7c0d80", function () {
      api.rerender('ef7c0d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/NovelCreatePage.vue"
export default component.exports